import { type HeightSettings } from '@blaze-runtime/engine-domain';

/** Used when a `fitContent` height omits `minHeight`. */
export const DEFAULT_FIT_CONTENT_MIN_HEIGHT = 32;
/** Used when a `fixed` height omits `height`. */
export const DEFAULT_FIXED_HEIGHT = 100;

interface FitContentHeightStyle {
  $type: 'fitContent';
  minHeight?: number;
}

interface FixedHeightStyle {
  $type: 'fixed';
  height: number;
}

export type HeightStyle = FitContentHeightStyle | FixedHeightStyle;

export function toHeightSettings(height: HeightStyle): HeightSettings {
  switch (height.$type) {
    case 'fitContent':
      return {
        mode: 'value',
        value: height.minHeight ?? DEFAULT_FIT_CONTENT_MIN_HEIGHT,
        fixed: false,
      };
    case 'fixed':
      return {
        mode: 'value',
        value: height.height ?? DEFAULT_FIXED_HEIGHT,
        fixed: true,
      };
  }
}

/** Inverse of {@link toHeightSettings}. `auto`/fixed-value settings invert to `fixed` - lossy but harmless. */
export function toHeightStyle(height: HeightSettings): HeightStyle {
  if (height.mode === 'value' && height.fixed === false) {
    return { $type: 'fitContent', minHeight: height.value };
  }
  if (height.value === undefined) {
    throw new Error('Missing element height');
  }
  return { $type: 'fixed', height: height.value };
}
